import { 
    GET_INVOICES_FAIL, 
    GET_INVOICES_LOADING, 
    GET_INVOICES_SUCCESS, 
    POST_INVOICES_FAIL, 
    POST_INVOICES_LOADING,
    POST_INVOICES_SUCCESS,
    POST_REQUEST_CONTROL_NUMBER_FAIL,
    POST_REQUEST_CONTROL_NUMBER_LOADING,
    POST_REQUEST_CONTROL_NUMBER_SUCCESS} from "../Components/Constants/ActionTypes";
import AxiosHelper from "../Helpers/AxiosHelper";

export const getInvoiceList = (params)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
        dispatch({
            type:GET_INVOICES_LOADING
        });
    
        AxiosHelper.get(`/invoices/`,{
            params:params
        }).then(
            (res)=>{
                dispatch({
                    type:GET_INVOICES_SUCCESS,
                    payload:res.data
                })
                resolve(res.data);
            }
        ).catch(
            (err)=>{
                dispatch({
                    type:GET_INVOICES_FAIL,
                    payload:err.response.data.message,
                })
                reject(err)
            }
        )
    })
}

export const postInvoice = (payload)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
        dispatch({
            type:POST_INVOICES_LOADING
        });
    
        AxiosHelper.post('/invoices/',{payload}).then(
            (res)=>{
                dispatch({
                    type:POST_INVOICES_SUCCESS,
                    payload:res.data
                })
    
                resolve(res.data);
            }
    
        ).catch(
            (err)=>{
                dispatch({
                    type:POST_INVOICES_FAIL,
                    payload:err?.response?.data?.message,
                })
                reject(err)
            }
        )
    })
}

export const requestControlNumber = (payload)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
        dispatch({
            type:POST_REQUEST_CONTROL_NUMBER_LOADING
        });
    
        AxiosHelper.post('/invoices/request-control-number',{payload}).then(
            (res)=>{
                dispatch({
                    type:POST_REQUEST_CONTROL_NUMBER_SUCCESS,
                    payload:res.data
                })
    
                resolve(res.data);
            }
    
        ).catch(
            (err)=>{
                dispatch({
                    type:POST_REQUEST_CONTROL_NUMBER_FAIL,
                    payload:err?.response?.data?.message,
                })
                reject(err)
            }
        )
    })
}

export const postFireTransaction = (payload)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
    
        AxiosHelper.post('/invoices/firearm',{payload}).then(
            (res)=>{
    
                resolve(res.data);
            }
    
        ).catch(
            (err)=>{
                reject(err)
            }
        )
    })
}

export const getFireTransactionDetails = (params)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
    
        AxiosHelper.get('/invoices/firearm/details',{
            params
        }).then(
            (res)=>{
    
                resolve(res.data);
            }
    
        ).catch(
            (err)=>{
                reject(err)
            }
        )
    })
}